import React from 'react';
import classNames from 'classnames';
import Button from '../Button';

import Icon from '../Icon';
import './AreaDocument.scss';

const AreaDocument = ({ active, headline, strapline, itemTypeWalkthrough, icon, small, onView, onDelete, onImageClicked, onEdit,user }) => (
  <div style={{ position: 'relative',zIndex:0 }}>
    <div
      className={
        classNames(
          'areadocuments__item',
          {
            'areadocuments__item--active': active,
            'areadocuments__item--small': small
          }
        )
      }
      onClick={() => onView()}


    >



      <div className={
        classNames(
          "areadocuments__icon",
          {
            'areadocuments__icon--delete': onDelete ? true : false
          }
        )
      }
        onClick={() => onImageClicked ? onImageClicked() : null}
      >
        {icon ? icon : (
          <Icon
            weight="light"
            glyph="file-contract"
          />
        )}


      </div>

      {headline ? <div className="areadocuments__details">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div className="areadocuments__headline">{headline}</div>
        </div>
        <div className="areadocuments__strapline">{strapline}</div>
        {itemTypeWalkthrough ? <div className="areadocuments__itemType">{itemTypeWalkthrough}</div> : <div />}

      </div> : null}

    </div>
    {(user.roles[0].role.name === "Strata Manager" || user.roles[0].role.name === "Home Owner" || user.roles[0].role.name === "Realtor") ? null :  <div className="areadocuments__delete" >
      <Button
        color="semantic"
        label={(
          <Icon
            glyph="pencil"
            weight="light"
          />
        )}
        onClick={() => onEdit()}

      />
      <div style={{ marginLeft: 12 }}>
        <Button
          color="semantic"
          label={(
            <Icon
              glyph="trash"
              weight="light"
            />
          )}
          onClick={() => onDelete()}
        />
      </div>
    </div>}
  </div>
)


export default AreaDocument;
